import { Controller } from "stimulus"
import notify from "../packs/notify"
import axios from "axios"
export default class extends Controller {
  static targets = [ 'assignResultButton', 'parentCheckbox', 'childCheckbox', 'parentForm', 'pencilSpecimen', 'specimenFrame', 'plusSpecimen', 'specimenTestBlock', 'collapseAll']

  connect(){
    this.collapseAllTarget.focus()
    this.clearCheckboxes()
    this.element.addEventListener("turbo:frame-render", (e)=> this.handleFrame(e))

    this.childCheckboxTargets.forEach((checkbox) => {
      checkbox.addEventListener("keyup", this.handleTabKey.bind(this));
    });
  }

  disconnect(){
    this.childCheckboxTargets.forEach((checkbox) => {
      checkbox.removeEventListener("keyup", this.handleTabKey.bind(this));
    });
  }

  handleFrame(e){
    let element = e.target

    if(!!element.querySelector('#specimenFrameForm')){
      this.handleFrameForm(element)
    }

    if(!!element.querySelector('#specimenBulkFrame')){
      this.handleBulkForm(element)
    }
  }


  handleFrameForm(element){
    const closeButton = this.closeButton();

    const iconElement = this.getIconElemenById(element.id)
    this.changeDataIcon(iconElement,'fa-plus')

    // submit form on Tab event of test result form
    const buttonElement = element.querySelector('form #validate-result-input')
    buttonElement && buttonElement.addEventListener('keyup', (event)=>{
      if (event.key == 'Tab') {
        $(element).find("form").trigger('submit')
        this.clickNextPencilIcon(element.id)
      }
    })

    this.appendCloseButtonFrameForm(element.querySelector("form"), closeButton, element)

    $(element)
    .find("form#test_result_entry")
    .on("ajax:success", (e, data) => {
      if (!(e.target instanceof HTMLFormElement)) return

      notify({message: 'Test result added successfully', status: 'success'})
      closeButton.remove()
      this.clearElement(element)
      document.querySelector(`[data-mass-assign-results-target=plusSpecimen][data-turbo-frame=${element.id}]`).click()
      this.handleFollowOnTestsModal(data.follow_on_test_data)
    })
    .on("ajax:error", () => {
      notify({message: 'Something went wrong', status: 'error'})
    })
  }

  handleBulkForm(element){
    let closeButton = this.closeButton();
    this.appendCloseButtonBulkForm(element.querySelector("#specimenBulkFrame"), closeButton, element)
    $(element)
      .find("form#test_result_entry")
      .on("ajax:success", (e, data) => {
        if (!(e.target instanceof HTMLFormElement)) return

        notify({message: data.message, status: data.status})
        this.clearCheckboxes()
        closeButton.remove()
        this.clearElement(element)
        this.assignResultButtonTarget.classList.toggle('disabled')
        this.assignResultButtonTarget.classList.remove('d-none')

        this.handleFollowOnTestsModal(data.follow_on_test_data, data.delayed_job)
      })
      .on("ajax:error", () => {
        notify({message: 'Something went wrong', status: 'error'})
      })
  }

  handleFollowOnTestsModal(followOnTestData, delayedJob){
    if(followOnTestData?.follow_on_test_ids?.length > 0 ){
      axios({url: '/test_results/follow_on_tests_modal', method: 'POST', data: {
        follow_on_test_data: followOnTestData,
        delayed_job: delayedJob
      }}).then(res => {
        // We used here innerHTML. It can be refactored to morphdom
        // https://github.com/patrick-steele-idem/morphdom
        document.querySelector('turbo-frame#modal').innerHTML= res.data
      })
    }
  }


  releaseAllTests(e){
    e.preventDefault()
    const arrayOfIds = this.allStsIds
    // during request disable button and change text
    e.target.disabled = true
    const disableWithText = e.target.dataset.disableWith
    const buttonText =e.target.textContent
    e.target.textContent = disableWithText

    axios({url: '/specimen_test_schedules/mark_all_as_released', method: 'POST', params:{
      specimen_test_schedule_ids: arrayOfIds.join(',')
    }}).then((res)=>{
      notify({status: res.data.status, message: res.data.message })
      this.handleFollowOnTestsModal(res.data.follow_on_test_data, false)
    }).finally(()=>{
      e.target.disabled = false
      e.target.textContent = buttonText
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    } )
  }

  openFrameForm(specimen_id,stsIds){
    const params = new URLSearchParams()

    stsIds.forEach(id => params.append('sts_ids[]', id))

    const url = `/test_results/${specimen_id}/specimen_test_schedule_form?` + params.toString();

    Turbo.visit(url, {frame: `specimen_${specimen_id}`})
  }

  handleTabKey(event){
    event.preventDefault();

    const specimenId = event.target.dataset['id']
    const stsIds = event.target.dataset['stsIds']
    const stsIdsParse = JSON.parse(stsIds)

    if (event.key === 'Tab') {
      this.openFrameForm(specimenId, stsIdsParse)
    }
  }

  clearCheckboxes(){
    this.parentCheckboxTarget.checked = false

    this.changeCheckChild(false)
  }

  changeCheckChild(checked = false){
    this.childCheckboxTargets.forEach(element => {
      element.checked = checked
    });
  }

  checkAll(e){
    if (e.target.checked){
      this.changeCheckChild(true)
    }else{
      this.changeCheckChild(false)
    }
    this.changeAssignResultStatus()
  }

  checkOne(){
    this.changeAssignResultStatus()
  }

  changeAssignResultStatus(){
    if(this.childCheckboxTargets.some((e)=> e.checked)){
      this.enableAssignResultButton()
    }else{
      this.disableAssignResultButton()
    }
  }

  enableAssignResultButton(){
    this.assignResultButtonTarget.classList.remove('disabled')
    this.assignResultButtonTarget.classList.add('enabled')
  }

  disableAssignResultButton(){
    this.assignResultButtonTarget.classList.remove('enabled')
    this.assignResultButtonTarget.classList.add('disabled')
  }

  bulkResultsForm(e){
    e.preventDefault()
    e.target.disabled = true
    e.target.querySelector('.spinner-border').classList.remove('d-none')

    axios({url: '/test_results/mass_assign_bulk_form', method: 'POST',
           data: {
            sts_ids: this.checkedStsIds,
            test_identifier: this.testIdentifier,
           }
          }
      )
    .then(html => {
      $('#mass_assign_bulk_form').html(html.data)

      if(document.querySelector('#mass_assign_bulk_form')){
        this.handleBulkForm(document.querySelector('#mass_assign_bulk_form'))
      }
    })
    .finally(()=> {
      e.target.disabled = false
      e.target.querySelector('.spinner-border').classList.add('d-none')
    })
  }

  appendCloseButtonBulkForm(parentElement, childElement, frame){
    childElement.addEventListener('click',(e)=>{
      e.preventDefault()
      this.clearElement(frame)
      childElement.remove()
      this.assignResultButtonTarget.classList.remove('d-none')
    })

    this.assignResultButtonTarget.classList.add('d-none')

    parentElement.parentNode.insertBefore(childElement, parentElement)
  }

  appendCloseButtonFrameForm(parentElement, childElement, frame){
    childElement.addEventListener('click',(e)=>{
      e.preventDefault()
      this.clearElement(frame)
      childElement.remove()
    })

    parentElement.parentNode.insertBefore(childElement, parentElement)
  }

  clickNextPencilIcon(specimenId){
    const foundElement = this.pencilSpecimenTargets.find(e => e.dataset['turboFrame'] === specimenId)
    const indexOfFoundElement = this.pencilSpecimenTargets.indexOf(foundElement)
    if(indexOfFoundElement >= 0){
      const nextPencil =  this.pencilSpecimenTargets[indexOfFoundElement + 1]
      nextPencil &&  nextPencil.click()
    }
  }

  closeButton(){
    const divElement = document.createElement("div")
    const buttonElement = document.createElement("button");
    const iconElement = document.createElement('i');
    const iconText = document.createTextNode('Close Test Entry');

    buttonElement.classList.add(...['btn','btn-link', 'text-danger'])
    iconElement.appendChild(iconText)
    iconElement.classList.add(...['fa','fa-times-circle'])

    buttonElement.appendChild(iconElement)
    divElement.appendChild(buttonElement)
    return divElement
  }

  plusClick(e){
    let iconElement = e.target.firstElementChild

    if (e.target.nodeName === 'I'){
      iconElement = e.target
    }

    let aElement = iconElement.parentElement
    let spcimenFrameDataId = aElement.dataset['turboFrame']

    if(this.checkExistFrame(spcimenFrameDataId, 'specimenFrameData')){
      this.changeDataIcon(iconElement, 'fa-plus')
      this.getFrameById(spcimenFrameDataId) && this.clearElement(this.getFrameById(spcimenFrameDataId))
      e.preventDefault()
    }else{
      this.changeDataIcon(iconElement, 'fa-minus')
    }
  }

  deleteSpecimenTestBlock(e){
    e.preventDefault()

    let iconElement = e.target.firstElementChild

    if (e.target.nodeName === 'SPAN'){
      iconElement = e.target
    }

    let buttonElement = iconElement.parentElement

    const  blockId = buttonElement.dataset.formDiv
    const blockElement = this.specimenTestBlockTargets.find( el=> el.id === blockId)

    blockElement && $(blockElement).fadeOut('slow', ()=>{ blockElement.remove()})
  }

  changeDataIcon(iconElement, className){
    iconElement.classList.remove('fa-plus')
    iconElement.classList.remove('fa-minus')

    iconElement.classList.add(className)
  }


  clearElement(element){
    $(element).html("")
  }

  getFrameById(id){
    return document.querySelector(`turbo-frame[id="${id}"]`)
  }

  checkExistFrame(id, frameId){
    const frame = this.getFrameById(id)

    return frame && !!frame.querySelector(`#${frameId}`)
  }

  getIconElemenById(id){
    const element = document.querySelector(`[data-mass-assign-results-target=plusSpecimen][data-turbo-frame=${id}]`)

    return element.getElementsByTagName('i')[0]
  }

  expandAll(e){
    e.preventDefault()
    let data = {}

    this.childCheckboxTargets.forEach(el=>{
      const specimenId = el.dataset['id']
      const ids = el.dataset['stsIds']

      const parsedStsIds = JSON.parse(ids)
      data[specimenId] = parsedStsIds
    })

    e.target.disabled = true
    e.target.querySelector('.spinner-border').classList.remove('d-none')

    axios({url: 'specimen_test_schedules_data', method: 'POST',
           headers: {
            Accept: "text/vnd.turbo-stream.html"
          },
           data: data
          }
      )
    .then( (html) => {
        Turbo.renderStreamMessage(html.data)

        this.plusSpecimenTargets.forEach((el)=> {
          let iconElement = el.getElementsByTagName('i')[0]

          this.changeDataIcon(iconElement, 'fa-minus')
        })
      }
      )
    .finally(()=> {
      e.target.disabled = false
      e.target.querySelector('.spinner-border').classList.add('d-none')
    })
  }

  callapseAll(){
    this.plusSpecimenTargets.forEach((el)=> {
      let iconElement = el.getElementsByTagName('i')[0]

      this.changeDataIcon(iconElement, 'fa-plus')
      this.getFrameById(el.dataset['turboFrame']) && this.clearElement(this.getFrameById(el.dataset['turboFrame']))
    })
  }

  get checkedStsIds(){
    let stsIds = []

    this.childCheckboxTargets.forEach(e => {
      if(e.checked){
        const ids = e.dataset['stsIds']
        const parsedStsIds = JSON.parse(ids)
        stsIds.push(...parsedStsIds)
      }
    });
    return stsIds;
  }

  get testIdentifier() {
    return this.data.get("test-identifier-value")
  }

  get allStsIds(){
    let stsIds = []
    this.childCheckboxTargets.forEach(e=>{
      const ids = e.dataset['stsIds']

      const parsedStsIds = JSON.parse(ids)

      stsIds.push(...parsedStsIds)
    })

    return stsIds
  }
}
